<script setup lang="ts">
import logoImg from '~/assets/scss/static/logo/logo.png'

const userStore = useUserStore();
const isLogged = computed(() => userStore.isLogged)
watch(isLogged, async (newVal) => {
  if (newVal) {
    await navigateTo('/');
  }
});
</script>
<template>
  <ElContainer>
    <ElHeader>
      <div>
          <img class="logo" :src="logoImg" alt="闲来帮 Logo">
      </div>
      <div class="navbar">
        <NuxtLink to="/" class="menu-login">
          <div style="display:flex;height:30px;">
            <span>返回首页</span>
            <img src="../assets/scss/static/组 759@3x.png" style="height:30px;margin-left: 8px;">
          </div>
        </NuxtLink>
      </div>
    </ElHeader>
    <ElMain>
      <slot />
    </ElMain>
    <FooterDefault style="position: absolute;bottom: 0;"/>
  </ElContainer>
</template>

<style scoped lang="scss">
.el-container {
  position: relative;

  .el-header {
    position: fixed;
    top: 0;
    width: 100%;
    height:80px;
    z-index: 99;
    color: #444444;
    padding: 0 5vw;
    line-height: 60px;
    font-weight: bold;
    background: none;
    display: flex;
    justify-content: space-between;

    .logo {
      height:60px;
      margin: 10px
    }

    .navbar {
      display:flex;
      align-items: center;
      line-height: 30px;
      
      .menu-login {
        color: #0E2036;
        text-decoration: none;
        margin: 0 10px;
        padding: 0 10px;
      }
    }
  }
  .el-main {
    height: 100vh;
    position: relative;
    background-image: url(https://yys-mh.oss-cn-shenzhen.aliyuncs.com/quanyiweb/index/login.png)
  }
}
</style>
